import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

interface IProps {
    carouselList: ICarousel[];
}

interface ICarousel {
    id: number,
    title: string | React.ReactNode,
    content: string | React.ReactNode
    imageUrl: string,
    to: string,

}
const YogaCenterCarousel = ({ carouselList }: IProps) => {
    const [current, setCurrent] = useState<number>(0);
    const [isDragging, setIsDragging] = useState<boolean>(false);
    const [startX, setStartX] = useState<number>(0);
    const [dragOffset, setDragOffset] = useState<number>(0);
    const [autoSlide, setAutoSlide] = useState<boolean>(true);
    const navigate = useNavigate();
    const ref = useRef<HTMLDivElement>(null);
    const cardRef = useRef<HTMLDivElement>(null);

    const startAutoSlide = () => {
        return setInterval(() => {
            if (autoSlide) {
                setCurrent((curr) => (curr === carouselList.length - 1 ? 0 : curr + 1));
            }
        }, 3000);
    };

    const onDragStart = (e: React.MouseEvent | React.TouchEvent) => {
        const clientX = e.nativeEvent instanceof MouseEvent ? e.nativeEvent.clientX : (e as React.TouchEvent).touches?.[0].clientX;
        setIsDragging(true);
        setStartX(clientX);
        setAutoSlide(false);
    };

    const onDragMove = (e: React.MouseEvent | React.TouchEvent) => {
        if (!isDragging) return;
        const clientX = e.nativeEvent instanceof MouseEvent ? e.nativeEvent.clientX : (e as React.TouchEvent).touches?.[0].clientX;
        setDragOffset(clientX - startX);
    };

    const onDragEnd = (e: React.MouseEvent | React.TouchEvent) => {
        if (!isDragging) return;
        setIsDragging(false);
        const threshold = 100;
        if (dragOffset > threshold) {
            setCurrent((prev) => (prev === 0 ? carouselList.length - 1 : prev - 1));
        } else if (dragOffset < -threshold) {
            setCurrent((prev) => (prev === carouselList.length - 1 ? 0 : prev + 1));
        }
        setDragOffset(0);
        setAutoSlide(true);
    };

    const calcTranslateX = () => {
        const targetOffsetWidth = cardRef.current?.getBoundingClientRect().width ?? 320;
        const returnValue = current * targetOffsetWidth;
        return current === 0 ? 0 : `calc(${-(returnValue - dragOffset)}px + 4vw)`
    }

    useEffect(() => {
        const interval = startAutoSlide();
        return () => clearInterval(interval);
    }, [carouselList.length, autoSlide]);

    return <>
        <div style={{ display: "flex", overflowX: 'hidden', }} ref={ref}
            onMouseDown={onDragStart}
            onTouchStart={onDragStart}
            onMouseMove={onDragMove}
            onTouchMove={onDragMove}
            onMouseUp={onDragEnd}
            onTouchEnd={onDragEnd}
            onMouseLeave={onDragEnd}
        >
            <div style={{
                display: "flex", transform: `translateX(${calcTranslateX()})`,
                transition: isDragging ? "none" : "transform 0.5s ease",
                marginLeft: current === 0 || (carouselList.length - 1 === current) ? '2.134vw' : 0,
            }}>
                {carouselList.map((carousel, idx) =>
                    <div key={idx} style={{ paddingLeft: '3.2vw', width: '85.34vw', maxWidth: '409.632px', cursor: 'pointer' }} ref={idx === 0 ? cardRef : null} onClick={() => navigate(carousel.to)}>
                        <img src={carousel.imageUrl} width={'100%'} style={{ aspectRatio: '320/180', borderRadius: 4, marginBottom: 16 }} />
                        <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left', gap: 8, }}>
                            <div className="sub-title/st3" style={{ color: 'var(--baseblack)' }}>
                                {carousel.title}
                            </div>
                            <div className="body/b2" style={{ color: 'var(--secondarys500)', whiteSpace: 'pre-wrap' }}>
                                {carousel.content}
                            </div>
                        </div>
                    </div>)}
            </div>
        </div>
    </>
}

export default YogaCenterCarousel;